import { lazy, Suspense } from "react";

const shouldRenderAgentation = import.meta.env.VITE_ENV === "LOCAL";

// 어젠테이션 - local에서만 랜덜처리
const Agentation = shouldRenderAgentation
  ? lazy(async () => {
      const module = await import("agentation");
      return { default: module.Agentation };
    })
  : null;

export default function LocalAgentation() {
  if (!Agentation) return null;

  return (
    <Suspense fallback={null}>
      <Agentation />
    </Suspense>
  );
}
